import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Button } from "@/components/ui/button";
function HeaderContent() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const toggleMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);
  const handleLinkClick = () => setIsMobileMenuOpen(false);
  return <>
      {}
      <nav className="hidden md:flex items-center gap-8">
        {loading ? <div className="flex gap-8">
            {[1, 2, 3, 4].map(i => <div key={i} data-index={i} className="h-4 w-16 bg-white/10 animate-pulse rounded-sm" />)}
          </div> : menuItems.map((item, i) => <div key={item.id} data-index={i}>
              <Link to={item.href || "#"} className="group relative inline-block text-xs font-bold uppercase tracking-[0.2em] text-white transition-colors hover:text-white/90">
                {item.label}
                <span className="absolute -bottom-1 left-0 h-[1px] w-full origin-center scale-x-0 bg-white transition-transform duration-300 ease-out group-hover:scale-x-100" />
              </Link>
            </div>)}
      </nav>

      {}
      <div className="md:hidden">
        <Button variant="ghost" size="icon" onClick={toggleMenu} className="text-white hover:bg-white/10 hover:text-white" aria-label="Toggle menu">
          {isMobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </Button>
      </div>

      {}
      {isMobileMenuOpen && <div className="fixed inset-0 top-[60px] z-40 flex flex-col items-center justify-center gap-8 bg-black/95 backdrop-blur-xl p-8 md:hidden animate-in fade-in slide-in-from-top-5 duration-300">
          {loading ? <div className="flex flex-col gap-6 items-center">
              {[1, 2, 3, 4].map(i => <div key={i} data-index={i} className="h-6 w-32 bg-white/10 animate-pulse rounded-sm" />)}
            </div> : menuItems.map((item, i) => <div key={item.id} data-index={i} className="w-full text-center">
                <Link to={item.href || "#"} onClick={handleLinkClick} className="block text-2xl font-bold uppercase tracking-widest text-white transition-colors hover:text-white/70">
                  {item.label}
                </Link>
              </div>)}
        </div>}
    </>;
}
export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest('a[href]') as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute('href');
        if (!href) return;
        let hash = '';
        if (href.startsWith('#')) {
          hash = href;
        } else if (href.startsWith('/') && href.includes('#')) {
          const [path, hashPart] = href.split('#');
          if (path === '/' || path === window.location.pathname) {
            hash = '#' + hashPart;
          }
        }
        if (hash && hash !== '#') {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        }
      }
    };
    document.addEventListener('click', handleAnchorClick);
    return () => document.removeEventListener('click', handleAnchorClick);
  }, []);
  return <header id="header" className={`dark sticky top-0 z-50 w-full transition-all duration-500 ${isScrolled ? "bg-black/80 backdrop-blur-xl border-b border-white/5 py-4" : "bg-black py-6"}`}>
      <div className="container mx-auto flex items-center justify-between px-6 !bg-[url(https://definite-toad.10web.cloud/wp-content/uploads/2026/03/BLKN-Logo-White.png)]">
        {}
        <Link to="/" className="flex-shrink-0">
          <img src="https://blkn.com.au/wp-content/uploads/2026/03/BLKN-Logo-White-Marginised.png" alt="BLKN" className="h-10 w-auto object-contain" />
        </Link>

        {}
        <MenuProvider menu_id="16" className="flex items-center">
          <HeaderContent />
        </MenuProvider>
      </div>
    </header>;
}